import React from "react"
import { Link } from "gatsby"

import { rhythm, scale } from "../utils/typography"

class Layout extends React.Component {
  render() {
    const { location, title, children } = this.props
    const isRoot = location.pathname === `${__PATH_PREFIX__}/`
    return (
      <div
        style={{
          fontFamily: `IBM Plex Mono, console`,
          marginLeft: `auto`,
          marginRight: `auto`,
          maxWidth: rhythm(36),
          padding: `${rhythm(1.5)} ${rhythm(3 / 4)}`
        }}
      >
        {(!isRoot && (
          <header>
            <Link to="/">Back</Link>
          </header>
        )) ||
          null}
        {children}
        <footer>
          <a href="https://www.github.com/carlbarrdahl" target="_blank">
            GitHub
          </a>
        </footer>
      </div>
    )
  }
}

export default Layout
